/**
 * FormLabels component
 * Handles the behavior of form labels that act as placeholders
 * Hides the label when text is entered in the input field
 */
class FormLabels {
	constructor(container) {
		this.container = container;
		this.inputs = this.container.querySelectorAll('input[type="text"], input[type="email"]');
		this.init();
	}

	init() {
		this.inputs.forEach(input => {
			this.setupInput(input);
		});
	}

	setupInput(input) {
		// Find the associated sublabel
		const sublabel = input.parentElement.querySelector('.sublabel');
		if (!sublabel) return;

		// Check initial state
		this.updateLabelVisibility(input, sublabel);

		// Add event listeners
		input.addEventListener('input', () => {
			this.updateLabelVisibility(input, sublabel);
		});

		input.addEventListener('focus', () => {
			this.updateLabelVisibility(input, sublabel);
		});

		input.addEventListener('blur', () => {
			this.updateLabelVisibility(input, sublabel);
		});
	}

	updateLabelVisibility(input, sublabel) {
		const hasValue = input.value.trim().length > 0;

		if (hasValue) {
			sublabel.classList.add('sublabel--hidden');
		} else {
			sublabel.classList.remove('sublabel--hidden');
		}
	}

	// Static method to initialize all forms on the page
	static initializeAll() {
		const formContainers = document.querySelectorAll('.mpForm');
		formContainers.forEach((el) => {
			new FormLabels(el);
		});
	}

	// Static method to initialize with retry for dynamically loaded content
	static initializeWithRetry() {
		// Try immediately
		this.initializeAll();

		// Also try after delays for dynamically loaded content
		setTimeout(() => this.initializeAll(), 1000);
		setTimeout(() => this.initializeAll(), 2000);
	}
}

export default FormLabels;
